import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

declare global {
  interface Window {
    pgUserId: number;
    apiSettings: {
      nonce: string;
    };
  }
}

const GiftForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    recipientEmail: "",
    senderEmail: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!formData.firstName) newErrors.firstName = "First name is required";
    if (!formData.lastName) newErrors.lastName = "Last name is required";
    if (!emailRegex.test(formData.recipientEmail)) newErrors.recipientEmail = "Recipient email is invalid";
    if (!emailRegex.test(formData.senderEmail)) newErrors.senderEmail = "Your email is invalid";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   if (!validateForm()) return;

  //   setSubmitting(true);

  //   const dataToSend = {
  //     emailAddress: formData.recipientEmail,
  //     senderFirstName: window.pgUser.first_name,
  //     receiverFirstName: formData.firstName,
  //     listId: 345139,
  //     transactionalMessageId: 11346442,
  //     receiverLastName: formData.lastName
  //   };

  //     await axiosRequestData(
  //       'POST',
  //       '/wp-json/pg/v1/user/sendTransactionalMessage',
  //       dataToSend
  //     ).then((response) => {
  //       console.log("response is!!!! " , response);
  //       navigate("/thank-you");
  //     }).finally(() => {
  //       setSubmitting(false);
  //     });
  // }


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;

    setSubmitting(true);

    const senderFirstName = window.pgUser.first_name;
    const senderLastName = window.pgUser.last_name;

    try {
      const response = await fetch("/wp-json/pg/v1/user/sendTransactionalMessage", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'X-WP-Nonce': window.apiSettings.nonce
        },
        body: JSON.stringify({
          emailAddress: formData.recipientEmail,
          senderFirstName: senderFirstName,
          senderLastName: senderLastName,
          receiverFirstName: formData.firstName,
          listId: 345139,
          transactionalMessageId: 11346442,
          receiverLastName: formData.lastName
        }),
      });

      const data = await response.json();

      if (data.success) {
        window.history.replaceState(null, "", "/thank-you");
        navigate("/thank-you");
        window.location.reload();
      } else {
        console.log("not sent gift!!!!!!");
        setErrors({ general: data.data || "Failed to send gift. Please try again." });
      }
    } catch (error) {
      setErrors({ general: "Network error. Please check your connection." });
    } finally {
      setSubmitting(false);
    }
  }


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  return (
    <Box
      sx={{
        width: 458,
        height: 836,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: 3,
        backgroundColor: "#fff",
        margin: "auto",
        '@media (max-width: 480px)': {
            width: '100%'
        }
      }}
    >
        <img
            src={`https://members.performancegolf.com/wp-content/uploads/2025/03/icon-gift.png`}
            alt="Gift Icon"
            style={{ width: 70, height: 70, marginBottom: 10 }}
        />

        <Typography
            fontSize={25}
            textAlign="center"
            lineHeight="130%"
        >
            Tell Us Who You’re Gifting…
        </Typography>

        <Typography
            fontSize={25}
            fontWeight="bold"
            textAlign="center"
            lineHeight="130%"
        >
            A FREE Annual Membership
        </Typography>
        <Typography
            fontSize={25}
            textAlign="center"
            lineHeight="130%"
            sx={{'@media (max-width: 480px)': {
                    fontSize: '20px'
                }}}
        >
            To Player's Club.
        </Typography>

        <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%", maxWidth: 400, marginTop:"30px" }}>
            <Typography fontWeight="bold" sx={{ mb: 1 }}>
                Gift Recipient’s First Name:
            </Typography>
            <TextField
                fullWidth
                label={formData.firstName? "" : "Who’s getting a free membership"}
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
                InputLabelProps={{ shrink: false }}
                error={!!errors.firstName}
                helperText={errors.firstName}
                sx={{
                    width: "100%",
                    '@media (min-width: 480px)': {
                        width: "458px",
                    },
                    height: 52,
                    '& .MuiInputBase-root': {
                        height: 52,
                    },
                    '& .MuiInputLabel-root': {
                        fontSize: 14,
                        top: -8,
                    },
                    '& .MuiOutlinedInput-root': {
                        fontSize: 14,
                    },
                    mb: 3,
                }}
            />

            <Typography fontWeight="bold" sx={{ mb: 1 }}>
                Gift Recipient’s Last Name:
            </Typography>
            <TextField
                fullWidth
                label={formData.lastName? "" :"Gift recipient’s last name"}
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                InputLabelProps={{ shrink: false }}
                required
                error={!!errors.lastName}
                helperText={errors.lastName}
                sx={{
                  width: "100%",
                  '@media (min-width: 480px)': {
                      width: "458px",
                  },
                    height: 52,
                    '& .MuiInputBase-root': {
                        height: 52,
                    },
                    '& .MuiInputLabel-root': {
                        fontSize: 14,
                        top: -8,
                    },
                    '& .MuiOutlinedInput-root': {
                        fontSize: 14,
                    },
                    mb: 3,
                }}
            />

            <Typography fontWeight="bold" sx={{ mb: 1 }}>
                Gift Recipient’s Email:
            </Typography>
            <TextField
                fullWidth
                label={formData.recipientEmail ? "" : "We use this email to create their account"}
                name="recipientEmail"
                type="email"
                value={formData.recipientEmail}
                onChange={handleChange}
                required
                InputLabelProps={{ shrink: false }}
                error={!!errors.recipientEmail}
                helperText={errors.recipientEmail}
                sx={{
                  width: "100%",
                  '@media (min-width: 480px)': {
                      width: "458px",
                  },
                    height: 52,
                    '& .MuiInputBase-root': {
                        height: 52,
                    },
                    '& .MuiInputLabel-root': {
                        fontSize: 14,
                        top: -8,
                    },
                    '& .MuiOutlinedInput-root': {
                        fontSize: 14,
                    },
                    mb: 3,
                }}
            />

            <Typography fontWeight="bold" sx={{ mb: 1 }}>
                Your Email:
            </Typography>
            <TextField
                fullWidth
                label={formData.senderEmail ? "" : "So we know who gave the gift of great golf"}
                name="senderEmail"
                type="email"
                value={formData.senderEmail}
                onChange={handleChange}
                required
                InputLabelProps={{ shrink: false }}
                error={!!errors.senderEmail}
                helperText={errors.senderEmail}
                sx={{
                  width: "100%",
                  '@media (min-width: 480px)': {
                      width: "458px",
                  },
                    height: 52,
                    '& .MuiInputBase-root': {
                        height: 52,
                    },
                    '& .MuiInputLabel-root': {
                        fontSize: 14,
                        top: -8,
                    },
                    '& .MuiOutlinedInput-root': {
                        fontSize: 14,
                    },
                    mb: 3,
                }}
            />

            <Button
                type="submit"
                variant="contained"
                sx={{ width: "137px",height:"42px",fontSize:"16px", backgroundColor: "#355ADD", color: "#fff", textTransform: "none", "&:hover": {
                  backgroundColor: "#163190 !important",
                  }
              }}
                disabled={submitting}
            >
                {submitting ? <CircularProgress size={24} /> : "Send Gift"}
            </Button>
        </Box>
        {/* {errors.length > 0 && <Alert severity="error">{errors.join(", ")}</Alert>} */}
    </Box>
  );
};

export default GiftForm;
